// extracted by mini-css-extract-plugin
module.exports = {"link":"link__36x-9","container":"container__2HBF9"};